import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { IUser } from "../interfaces/user";

export interface IAuthStore {
	isGlobalLoader: boolean;
	user: IUser | null;
	setUser: (user: IUser | null) => void;
	setIsGlobalLoader: (isGlobalLoader: boolean) => void;
}

const useAuthStore = create<IAuthStore>()(
	devtools(
		(set) => ({
			isGlobalLoader: false,
			user: null,
			setUser: (user: IUser | null) => {
				set(
					(state) => {
						return {
							...state,
							user,
						};
					},
					false,
					"setUser",
				);
			},
			setIsGlobalLoader: (isGlobalLoader: boolean) => {
				set(
					(state) => {
						return {
							...state,
							isGlobalLoader,
						};
					},
					false,
					"setIsGlobalLoader",
				);
			},
		}),
		{
			name: "auth",
			enabled: !["production", "preprod"].includes(
				process.env.NODE_ENV as string,
			),
			store: "fraud-app-auth",
		},
	),
);

export { useAuthStore };
